import {fsa, fsaError, fsaPayload} from './helpers'

export const GET_SHOWROOM_LOCATIONS = 'get showroom locations request'
export const getShowroomLocations = fsa(GET_SHOWROOM_LOCATIONS)

export const GET_SHOWROOM_LOCATIONS_FAILURE = 'get showroom locations request failure'
export const getShowroomLocationsFailure = fsaError(GET_SHOWROOM_LOCATIONS_FAILURE)

export const GET_SHOWROOM_LOCATIONS_PENDING = 'get showroom locations request pending'
export const getShowroomLocationsPending = fsa(GET_SHOWROOM_LOCATIONS_PENDING)

export const GET_SHOWROOM_LOCATIONS_SUCCESS = 'get showroom locations request success'
export const getShowroomLocationsSuccess = fsaPayload(GET_SHOWROOM_LOCATIONS_SUCCESS)
